function removeEventListener<EventType = Event>(
  target: EventTarget,
  event: string,
  callback: (evt: EventType) => void,
  options?: boolean | AddEventListenerOptions
) {
  target.removeEventListener(
    event,
    callback as unknown as EventListener,
    options
  );
}

export default removeEventListener;
